import { Image } from '@infl-ts/util-fetch-challenge-list';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { JsonFromString } from 'io-ts-types';
var Prospect = t.type({
  name: t.string,
  title: nullable(t.string),
  company: nullable(t.string)
});
export var Challenge = t.type({
  headline: t.string,
  description: t.string,
  banner: nullable(Image),
  hideBannerImage: t["boolean"],
  prospect: nullable(Prospect)
});
export var PreviewStage = t.type({
  id: t.string,
  name: t.string
});
export var ChallengePreview = JsonFromString.pipe(t.type({
  challenge: Challenge,
  stages: t.array(PreviewStage)
}));